import { DashboardCard } from '@/src/features/dashboard/presentation/components/DashboardCard'
import { appColors } from '@/src/theme/foundations/colors'
import { Box, Flex, MenuList, MenuOptionGroup, Text, Tooltip } from '@chakra-ui/react'
import { FlexCol } from '@components'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { SearchBox } from '../../SearchBox/SearchBox'
import { MenuItem } from '../../ui/Menu'

export interface ICompanySelectOption {
  value: number
  label: string
  id: number
  firebaseId: string
}

interface CompanySelectMenuListProps {
  isOpen: boolean
  activeSearchBoxId: number
  setActiveSearchBoxId: (id: number) => void
  onClick: () => void
  companyOptions: ICompanySelectOption[]
  hoveredCompanyIndex: number
  selectedCompanyIndex: number
  companySearchTerm: string
  handleCompanySearch: (value: string) => void
  handleCompanyHoveredChange: (value: number) => void
}

export const CompanySelectMenuList = ({
  isOpen,
  activeSearchBoxId,
  setActiveSearchBoxId,
  onClick,
  companyOptions,
  hoveredCompanyIndex,
  selectedCompanyIndex,
  companySearchTerm,
  handleCompanySearch,
  handleCompanyHoveredChange,
}: CompanySelectMenuListProps) => {
  const { t } = useTranslation()

  useEffect(() => {
    if (!isOpen) {
      handleCompanyHoveredChange(selectedCompanyIndex)
    }
  }, [isOpen, selectedCompanyIndex])

  return (
    <MenuList zIndex={100} style={{ backgroundColor: 'transparent', border: 'none', padding: 0, boxShadow: 'none' }}>
      <Flex gap='10px'>
        <DashboardCard padding={3} onClick={() => setActiveSearchBoxId(0)}>
          <FlexCol gap='6px'>
            <Flex width='20vw' maxWidth='350px' gap='4px' alignItems='center'>
              <Text fontSize={14} color={appColors.foreground} fontWeight='bold'>
                {t('company')}
              </Text>
            </Flex>
            <SearchBox value={companySearchTerm} id={0} focusId={activeSearchBoxId} onChange={handleCompanySearch} />
            <Box maxW='350px' width='20vw' maxH='340px' overflowY='auto' overflowX='hidden' className='innerScrollBar'>
              <MenuOptionGroup value={String(hoveredCompanyIndex)} onClick={() => onClick?.()}>
                {companyOptions.map(option => (
                  <MenuItem
                    display={'block'}
                    key={option.value}
                    value={String(option.value)}
                    closeOnSelect={true}
                    aria-selected={option.value === hoveredCompanyIndex ? 'true' : 'false'}
                    onClick={onClick}
                    onMouseEnter={() => {
                      if (!isOpen) return
                      handleCompanyHoveredChange(Number(option.value))
                    }}
                    class='standard'
                    isSelected={hoveredCompanyIndex === option.value}
                  >
                    {option.label.length < 20 ? (
                      <Text fontSize='14px'>{option.label}</Text>
                    ) : (
                      <Tooltip hasArrow label={option.label} bg='white' color={appColors.foreground} fontSize={'14px'}>
                        <Text fontSize='14px'>{option.label}</Text>
                      </Tooltip>
                    )}
                  </MenuItem>
                ))}
              </MenuOptionGroup>
            </Box>
          </FlexCol>
        </DashboardCard>
      </Flex>
    </MenuList>
  )
}
